import { render, staticRenderFns } from "./unitItem.vue?vue&type=template&id=dc5c8220"
import script from "./unitItem.vue?vue&type=script&lang=js"
export * from "./unitItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports